// removed by extract-text-webpack-plugin
module.exports = {"card":"card__1_oBf"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Experience/styles.css
// module id = 1488
// module chunks = 0